import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import UILink from 'UIComponents/link/UILink';
import { View } from 'foundations-components/components/View';
import { useLocation } from 'react-router-dom';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import { getLoginUrlWithRedirect } from '../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const GenericError = () => {
  const {
    pathname
  } = useLocation();
  return /*#__PURE__*/_jsxs(UIErrorMessage, {
    title: unescapedText('appMarketplace.error.default.title'),
    children: [/*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "appMarketplace.error.default.body"
      })
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "appMarketplace.error.default.cta_jsx",
        options: {
          onRefresh: () => window.location.reload(),
          loginUrl: getLoginUrlWithRedirect(pathname)
        },
        elements: {
          Link: UILink
        }
      })
    }), /*#__PURE__*/_jsx(View, {
      marginBlockStart: "400",
      children: /*#__PURE__*/_jsx(UIRouterButton, {
        use: "tertiary",
        to: "/",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "appMarketplace.error.notFound.button"
        })
      })
    })]
  });
};
export default GenericError;